import React from "react";
import {observer} from "mobx-react-lite";
import ResidentAdminPage from "../../components/templates/residentAdmin/residentAdminPage";
import {useStores} from "../../stores/useStores";
import withRedirectWithoutASelectedVillage from "../../utils/auth/withRedirectWithoutASelectedVillage";

const IndependentResidentAdmin: React.FC = () => {
  const {
    domainStore: {independentResidentAdminDomainStore},
    uiStore: {independentResidentAdminUiStore}
  } = useStores();

  return (
    <ResidentAdminPage
      residentAdminDomainStore={independentResidentAdminDomainStore}
      residentAdminUiStore={independentResidentAdminUiStore}
    />
  );
};

export default withRedirectWithoutASelectedVillage(
  observer(IndependentResidentAdmin)
);
